import { VariantColor } from '@repo/toolkit/colors'
import { DateFormatter } from '@repo/toolkit/date'

import { t } from '../../../../locale/utils'
import { missionStatusEnumMapping } from '../../enums/mission/mission-status.enum'
import { staffQualificationEnumMapping } from '../../enums/staff/staff-qualifications.enum'
import { MissionLight } from '../mission/mission'

export class MissionTrackingProperties {
  static getBadgeVariant(mission: MissionLight): VariantColor {
    return missionStatusEnumMapping[mission.status].variant
  }

  static getLabel(mission: MissionLight): string {
    const data: string[] = []
    const { qualifications, date, title } = mission
    const q = qualifications.map((q) => t(staffQualificationEnumMapping[q].label)).join(', ')

    data.push(q)
    data.push(DateFormatter.DDMMYYYY(date))
    data.push(title)

    return data.filter(Boolean).join(' - ')
  }

  static getDescription(mission: MissionLight) {
    const variant = this.getBadgeVariant(mission)
    const label = this.getLabel(mission)

    return { label, variant }
  }
}
